<template>
  <div class="card">
      <form class="form">
        <div class="card-body">
          <div class="row ">
            <div class="col-12 col-md-8 col-lg-8">
              <div class="row d-flex align-items-center">
                <div class="col-12 col-md-2 col-lg-2">
                  <h4>{{$t('mail.a')}} <span class="text-danger">*</span></h4>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                  <TagInput
                    containerClass="form-group mb-5"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    v-model="formData.to"
                    :name="`to`"
                    :helper-text="$t('invoice.help_mail_tag')"
                    :existingTags="contactSuggestions"
                    :includeSelectedTags="true"
                    :closeOnSelect="true"
                    :is-required="!formData.is_draft"
                  />
                </div>
              </div>

              <div class="row align-items-center" v-show="showCc">
                <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.cc')}} <i class="fa fa-minus-circle fs-4 ms-3 cursor-pointer" @click.stop="showCc = false" style="color: #303D4E;"></i></h4>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                  <TagInput
                    containerClass="form-group mb-5"
                    type="email"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    v-model="formData.cc"
                    :name="`cc`"
                    :helper-text="$t('invoice.help_mail_tag')"
                    :existingTags="contactSuggestions"
                    :includeSelectedTags="true"
                    :closeOnSelect="true"
                  />
                </div>
              </div>

              <div class="row align-items-center" v-show="showCci">
                <div class="col-12 col-md-2 col-lg-2">
                    <h4>CCi <i class="fa fa-minus-circle fs-4 ms-3 cursor-pointer" @click.stop="showCci = false" style="color: #303D4E;"></i></h4>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                  <TagInput
                    containerClass="form-group mb-5"
                    type="email"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    v-model="formData.bcc"
                    :name="`bcc`"
                    :helper-text="$t('invoice.help_mail_tag')"
                    :existingTags="contactSuggestions"
                    :includeSelectedTags="true"
                    :closeOnSelect="true"
                  />
                </div>
              </div>
              <div class="row align-items-center" v-show="showTag">
                <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.tagProject')}} <i class="fa fa-minus-circle fs-4 ms-3 cursor-pointer" @click.stop="showTag = false" style="color: #303D4E;"></i></h4>
                </div>
                <div class="col-12 col-md-10 col-lg-10">
                  <Select2
                      containerClass="form-group mb-5"
                      :name="`model_ids`"
                      :multiple="true"
                      selectClass="form-select-lg form-select-solid form-control-lg"
                      :isRequired="false"
                      :placeholderText="$t('mail.help_project_tag')"
                      v-model="formData.model_ids"
                  >
                    <option v-for="(project, index) in projectsFormatted" :key="project.value" :value="project.value">
                      {{ project.name }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4">
              <div class="d-flex justify-content-between align-items-center mt-5">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center me-5" v-show="!showCc">
                    <i class="fa fa-plus-circle fs-4 me-3 cursor-pointer" @click.stop="showCc = true" style="color: #303D4E;"></i>
                    <h5 class="mt-1">{{$t('mail.cc')}}</h5>
                  </div>
                  <div class="d-flex align-items-center me-5" v-show="!showCci">
                    <i class="fa fa-plus-circle fs-4 me-3 cursor-pointer" @click.stop="showCci = true" style="color: #303D4E;"></i>
                    <h5 class="mt-1">CCi</h5>
                  </div>
                  <div class="d-flex align-items-center" v-show="!showTag">
                    <i class="fa fa-plus-circle fs-4 me-3 cursor-pointer" @click.stop="showTag = true" style="color: #303D4E;"></i>
                    <h5 class="mt-1">{{$t('mail.tagProject')}}</h5>
                  </div>
                </div>
                <div v-if="!formData.email_id">
                  <span class="btn btn-sm btn-primary" @click="openProgramModal">{{ $t('mail.send_program') }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row border-bottom">
            <div :class="showDate ? 'col-12 col-md-8 col-lg-8' : 'col-12'">
              <div class="row align-items-center">
                  <div :class="showDate ? 'col-12 col-md-2 col-lg-2' : 'col-12 col-md-1 col-lg-1'">
                      <h4>{{$t('mail.subject')}} <span class="text-danger">*</span></h4>
                  </div>
                  <div :class="showDate ? 'col-12 col-md-10 col-lg-10' : 'col-12 col-md-11 col-lg-11'">
                    <Input
                      container-class="form-group mb-5"
                      :name="`subject`"
                      type="text"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      v-model="formData.subject"
                      :is-required="!formData.is_draft"
                    />
                  </div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-lg-4" style="margin-top: -20px;">
              <InputDate
                :name="'date'"
                type="text"
                :label="$t('mail.choose_date')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="showDate" 
                v-if="showDate"
                size="lg"
                placeholder="d-m-Y H:i"
                containerClass="form-group mb-5"
                dateFormat="d-m-Y H:i"
                :enableTime="true"
                v-model="formData.scheduled_at"
                :enablePassTime="false"
                :clearable="true"
              />
            </div>
          </div>
          
          <div class="row mt-5">
              <div class="col-12 col-md-9 col-lg-9">
                <CKEditor
                    :id="'mail-editor'"
                    container-class="h-400px"
                    :content="formData.message"
                    @text="getDescription"
                    ref="ckeditor"
                    @ready="onEditorReady"
                />
              </div>
              <div class="col-12 col-md-3 col-lg-3">
                <div class="card border_style">
                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <h2>{{$t('pipelines.attach_files')}}</h2>
                      <span class="badge badge-light-warning fs-2 mb-2 ms-3">{{fileCount}}</span>
                    </div>
                  </div>
                  <div class="card-body p-5">
                    <div style="overflow-y: auto; max-height: 280px !important;">
                      <UploadFile :id="'upload_file2'" :size="2" :number="20" v-model="formData.attachments"/>
                    </div>
                  </div>
                </div>
              </div>
          </div>


          <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mt-20 mb-5 fs-6">
            <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" :href="'#kt_settings'">{{ $t("menu.settings") }}</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" :href="'#kt_signature'">{{ $t("menu.signature") }}</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" :id="'kt_settings'" role="tabpanel">
              <div class="d-flex align-items-center gap-4">
                <div class="form-check me-5 mt-2">
                  <input class="form-check-input" type="checkbox" v-model="formData.request_receipt" id="flexCheckDefault"/>
                  <label class="ms-2 form-label fs-6 text-black" for="flexCheckDefault">
                    {{ $t('mail.request_receipt') }}
                  </label>
                </div>

                <div class="d-flex align-items-center gap-3 mt-1">
                  <span class="me-2 form-label fs-6 text-black mt-1">{{ $t('mail.priority') }}</span>
                  <Select2
                    containerClass="col-12"
                    :name="`priority`"
                    :multiple="false"
                    selectClass="form-select-sm form-select-solid form-control-sm"
                    :isRequired="false"
                    :placeholderText="$t('mail.priority')"
                    v-model="formData.priority"
                  >
                    <option v-for="(priority, index) in priorities" :key="index" :value="priority.value">
                      {{ priority[locale] }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" :id="'kt_signature'" role="tabpanel">
              <div class="d-flex align-items-center gap-3">
                <span class="me-2 form-label fs-6 text-black">{{ $t('menu.select_signature') }}</span>
                <Select2
                  containerClass="col-6"
                  :name="`signature`"
                  :multiple="false"
                  selectClass="form-select-sm form-select-solid form-control-sm"
                  :isRequired="false"
                  :placeholderText="$t('menu.select_signature')"
                  v-model="selectedSignature"
                  :IsInputGroup="true"
                  icon="bi bi-plus"
                  :clickAddon="openSignatureModal"
                  :clear="true"
                >
                  <option v-for="(signature, index) in signatures" :key="index" :value="signature.id">
                    {{ signature.name }}
                  </option>
                </Select2>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-end">
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" @click.prevent="() => submitForm(false)" btn-text="button.send" size="7px 30px" :is-disabled="!formData.to || !formData.to.length" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
  </div>

  <SignatureModal id="create_signature_modal" @load="loadData"/>
</template>

<script setup>
  import {ref, defineEmits, defineProps, watch, computed, onMounted, onBeforeUnmount} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import CKEditor from '@/components/CKEditor.vue';
  import UploadFile from "@/components/UploadFile";
  import TagInput from "@/components/TagifyInput.vue";
  import Select2 from "@/components/Select2";
  import {useLocales} from "@/composables/locales";
  import { useRoute } from "vue-router"
  import SignatureModal from "./SignatureModal.vue"
  import InputDate from "@/components/InputDate.vue";
  import {$formatToYmdHi, formatArray} from "@/mixins/Helpers";
  import RequiredText from "@/components/RequiredText.vue";


  const store = useStore()
  const {locale} = useLocales()
  const route = useRoute()

  const submitted = defineModel('submitted', { default: false })

  const props = defineProps({
    form: {
      type: Object,
      default: {
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        message: '',
        attachments: [],
        email_id: '',
        scheduled_at: '',
        priority: '3 (Normal)',
        request_receipt: false,
        folder: '',
        model_ids: [],
        is_draft: false
      }
    },
    closed: {
      type: Boolean,
      default: false
    }
  })
  const emits = defineEmits(['submitFunction', 'load', 'reply'])

  const isLoading = ref(false)
  const showCc = ref(false)
  const showCci = ref(false)
  const showTag = ref(false)
  const showDate = ref(false)
  const selectedSignature = ref('')
  const oldSelectedSignature = ref('')
  const ckeditor = ref(null)
  const formData = ref(props.form)

  const contacts = computed(() => store.getters['mails/getUserContacts'])
  const priorities = computed(() => store.getters['mails/getPriorities'])
  const activeSignature = computed(() => store.getters['mails/getActiveSignature'])
  const signatures = computed(() => store.getters['mails/getSignatures'])
  const fileCount = computed(() => formData.value.attachments?.length || 0)
  const folder = computed(() => decodeURIComponent(decodeURIComponent(route.query.tab)))
  const projects = computed(() => store.getters['projects/getProjectsCollection'])
  const projectsFormatted = computed(() => {
    return projects.value.map(el => ({name: el.title, value: el.id}))
  })

  const contactSuggestions = computed(() => {
    return contacts.value
      ?.filter(item => item.email)
      .map(item => {
        return `${item.fullname} <${item.email}>`;
      }) || [];
  });

  const removeElt = computed(() => {
    return signatures.value?.find(item => item.id === oldSelectedSignature.value);
  });
  const isDraft = computed(() => {
    if (ckeditor.value && ckeditor.value.editorInstance) {
      const editor = ckeditor.value.editorInstance
      const data = editor.getData().trim()
      const signatureHtml = `<p style="text-align: right;">${activeSignature.value?.content || ''}</p>`.trim()

      const parser = new DOMParser()
      const docContent = parser.parseFromString(data, 'text/html').body.textContent?.trim()
      const docSignature = parser.parseFromString(signatureHtml, 'text/html').body.textContent?.trim()

      if (docContent && docContent !== '' && docContent !== docSignature) {
        return true
      }

      return false
    }
  })

  watch(() =>
      props.form.email_id, () => {
    if(props.form.cc.length > 0 && props.form.email_id) {
      showCc.value = true
    }else {
      showCc.value = false
    }
    if(props.form.bcc.length > 0 && props.form.email_id) {
      showCci.value = true
    }else {
      showCci.value = false
    }

    if(props.form.model_ids.length > 0 && props.form.email_id) {
      showTag.value = true
    }else {
      showTag.value = false
    }


  });

  function getDescription(text) {
    if (formData.value.message !== text) {
      formData.value.message = text;
    }
  }

  watch(() => activeSignature.value, (value) => {
    if(value) {
      selectedSignature.value = activeSignature.value.id
    }
  });

  watch(() => selectedSignature.value, (newVal, oldVal) => {
    if (newVal !== oldVal) {
      oldSelectedSignature.value = oldVal;
      if (oldSelectedSignature.value && removeElt.value) {
        removeSignature(removeElt.value.content);
      }
      if(newVal){
        changeSignature();
      }
    }
  });

  function changeSignature() {
    if(selectedSignature.value) {
      store.dispatch('mails/selectSignature', selectedSignature.value).then((response) => {
        store.dispatch('mails/loadActiveSignatures').then((res) => {
          insertSignature(activeSignature.value?.content)
        })
      })
    }
  }

  function openSignatureModal(){
    $('#create_signature_modal').modal('toggle')
  }

  function onEditorReady(editor) {
    ckeditor.value.editorInstance = editor;
  }

  function insertSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    const htmlSignature = `<p style="text-align: right;">${variableText}</p>`;

    const viewFragment = editor.data.processor.toView(htmlSignature);
    const modelFragment = editor.data.toModel(viewFragment);

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();
      const endPosition = editor.model.createPositionAt(root, 'end');

      const emptyParagraph = writer.createElement('paragraph');
      editor.model.insertContent(emptyParagraph, endPosition);

      const newEndPosition = editor.model.createPositionAt(root, 'end');

      editor.model.insertContent(modelFragment, newEndPosition);

      writer.setSelection(editor.model.createPositionAt(root, 'end'));
    });
  }

  function removeSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;
    const model = editor.model;

    const viewFragment = editor.data.processor.toView(variableText);
    const modelFragment = editor.data.toModel(viewFragment);

    model.change(writer => {
      const root = model.document.getRoot();
      const range = model.createRangeIn(root);

      const elementsToRemove = Array.from(modelFragment.getChildren());

      for (const element of elementsToRemove) {
        for (const item of range.getItems()) {
          if (item.is('element') && item.name === element.name) {
            const itemData = item.getChild(0)?.data?.trim();
            const elementData = element.getChild(0)?.data?.trim();

            if (itemData === elementData) {
              writer.remove(item);
              break;
            }
          }
        }
      }
    });
  }

  function clearEditorContent() {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();

      for (const child of Array.from(root.getChildren())) {
        writer.remove(child);
      }

      const emptyParagraph = writer.createElement('paragraph');
      writer.insert(emptyParagraph, root, 'end');
      writer.setSelection(emptyParagraph, 'in');
    });
  }

  function loadForm() {
    resetForm()
    clearEditorContent()
    changeSignature()
  }

  function resetForm() {
    showCc.value = false
    showCci.value = false

    formData.value.to = []
    formData.value.subject = ''
    formData.value.message = ''
    formData.value.cc = []
    formData.value.bcc = []
    formData.value.attachments = []
    formData.value.scheduled_at = ''
    formData.value.priority = '3 (Normal)'
    formData.value.request_receipt = false
    formData.value.is_draft = false
    formData.value.folder = route.query.tab

    if(formData.value.email_id) emits('reply', false)
  }

  function openProgramModal(){
    showDate.value = !showDate.value
  }

  function submitForm(draft= false){
    submitted.value = true
    if(draft) formData.value.is_draft = !!draft
    isLoading.value = true;

    formData.value.folder = route.query.tab

    let data = {
      ...formData.value,
      scheduled_at: $formatToYmdHi(formData.value.scheduled_at),
      to: formatArray(formData.value.to),
      cc: formatArray(formData.value.cc),
      bcc: formatArray(formData.value.bcc)
    }


    store.dispatch('mails/createMail', data)
        .then((res) => {
          formData.value.email_id = ''
          store.dispatch('mails/loadMails', {folder: folder.value, page: 1})
          if(!draft) window.toastr['success'](i18n.global.t('mail.created_successfully'))
          window.close()
          loadForm()
        })
        .finally(() => isLoading.value = false)
  }

  function loadData() {
    store.dispatch('mails/loadSignatures')
    store.dispatch('mails/loadActiveSignatures')
  }

  onMounted(() => {
    loadData()
    store.dispatch("projects/loadProjectsCollection"),
    store.dispatch("mails/loadUsersAndContacts")
    store.dispatch("mails/loadPriorities")
  })

</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }

  .border_style {
    border: 2px solid var(--bs-light)
  }
</style>